import React, { Component } from 'react'
import { Box } from '@mui/material'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/pro-duotone-svg-icons/faTrashAlt'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class ConfirmDeleteChangesDialog extends Component {
    constructor(props) {
        super(props)

        this.state = {
            submitting: false,
        }
    }

    generateDialogFooter() {
        return (
            <>
                <StyledButton onClick={this.props.accept} color="error">
                    {this.state.submitting ? (
                        <LoadingDefault size={'sm'} as={'span'} />
                    ) : (
                        <FontAwesomeIcon icon={faTrashAlt} />
                    )}
                    &nbsp; {this.props.kedo.t('Delete')}
                </StyledButton>{' '}
                &nbsp;
                <StyledButton
                    onClick={() => this.props.cancel()}
                    color="secondary"
                >
                    {this.props.kedo.t('Cancel')}
                </StyledButton>
            </>
        )
    }

    getForm() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={this.props.kedo.t('Confirm delete')}
                onClose={() => this.props.cancel()}
                headerClose={() => this.props.cancel()}
                contentProps={{ dividers: true }}
                actions={this.generateDialogFooter()}
            >
                <Box component="form">
                    {this.props.kedo.t('confirm_delete_changes')}
                </Box>
            </AppDialog>
        )
    }

    render() {
        // if (this.props.variant === 'modal') {
        return this.getForm()
        // }

        // return  <Prompt
        //             when={this.props.when}
        //             message={() => this.getForm()}
        //         />
    }
}

export default ConfirmDeleteChangesDialog
